import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { CollectionsSection } from './components/CollectionsSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { LookInsideSection } from './components/LookInsideSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { ComparisonSection } from './components/ComparisonSection';
import { FaqSection } from './components/FaqSection';
import { FinalOfferSection } from './components/FinalOfferSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full max-w-full overflow-x-clip bg-night-950 pb-16 font-sans text-body lg:pb-0" data-id="element-0" data-mp="28sbb5328r364">
      <Hero data-id="element-1" data-mp="23t8gmcjw0fce" />

      <main data-id="element-2" data-mp="3ijxq4swlw4ky">
        <PainSection data-id="element-3" data-mp="3ik7e6ay3c1o0" />
        <CollectionsSection data-id="element-4" data-mp="3iiwdwl3utc1n" />
        <HowItWorksSection data-id="element-5" data-mp="3ijpcgysnsv8p" />
        <LookInsideSection data-id="element-6" data-mp="3mljat0fdtn5p" />
        <BonusesSection data-id="element-7" data-mp="3mkre1ma1tjdu" />
        <OfferSection data-id="element-8" data-mp="3mk83wrqn3zad" />
        <ComparisonSection data-id="element-9" data-mp="3mjg8bgx1m1k3" />
        <FaqSection data-id="element-10" data-mp="3rcj7q5oi4587" />
        <FinalOfferSection data-id="element-11" data-mp="3rbzngibdp4r0" />
      </main>

      <Footer data-id="element-12" data-mp="3recerm310rgq" />
      <StickyCta data-id="element-13" data-mp="3relvsk63foaa" />
    </div>;
}